import { Chip } from '@mui/joy';
import { TaskPriority, TASK_PRIORITY_LABELS } from '@/types/project';

const PRIORITY_COLORS: Record<TaskPriority, 'neutral' | 'warning' | 'danger'> = {
  low: 'neutral',
  medium: 'warning',
  high: 'danger',
};

export default function TaskPriorityChip({ priority }: { priority: TaskPriority }) {
  return (
    <Chip size="sm" variant="outlined" color={PRIORITY_COLORS[priority]}>
      {TASK_PRIORITY_LABELS[priority]}
    </Chip>
  );
}
